import { memo } from 'react'
import TagList from '../TagList'
import AIPromptText from '../AIPromptText'
import { IAiHistoryItemProps } from './types'
import * as Styled from './styled'

const AIHistoryItem: React.FC<IAiHistoryItemProps> = ({
  prompt,
  tags,
  content
}) => {
  return (
    <Styled.AIHistoryItemContainer>
      {prompt && <AIPromptText promptText={prompt} />}
      <TagList tags={tags} />
      {content}
    </Styled.AIHistoryItemContainer>
  )
}

export default memo(AIHistoryItem)
